import React, { ComponentType } from "react";
import { AlertTriangle } from "lucide-react";

interface WarningCardProps {
  children: React.ReactNode;
  icon?: ComponentType<{ className?: string }>;
  className?: string;
  variant?: "default" | "centered";
}

export function WarningCard({
  children,
  icon: Icon = AlertTriangle,
  className = "",
  variant = "default",
}: WarningCardProps) {
  const alignmentClass = variant === "centered" ? "items-center" : "items-start";
  const iconMarginClass = variant === "centered" ? "" : "mt-0.5";

  return (
    <div className={`p-3 bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded-lg ${className}`}>
      <div className={`flex gap-2 ${alignmentClass}`}>
        <Icon className={`w-4 h-4 text-amber-600 dark:text-amber-400 flex-shrink-0 ${iconMarginClass}`} />
        <div className="text-sm text-amber-900 dark:text-amber-100">
          {children}
        </div>
      </div>
    </div>
  );
}